<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/greennote.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          グリーンノート オンライン研修システム
        </h1>
      </v-col>

      <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          ここから研修を受けたり、資料を入手したりすることができます。
        </h2>
      </v-col>

      <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          コース一覧へ
        </h2>

        <v-row justify="center">
          <a
            v-for="(link, i) in courseGroups"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
          >
            {{ link.text }}
          </a>
        </v-row>
      </v-col>


      <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          リンク
        </h2>

        <v-row justify="center">
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ link.text }}
          </a>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HelloWorld',

    data: () => ({
      courseGroups: [
        {
          text: '無償コース',
          href: '/free',
        },
        {
          text: '有償コース',
          href: '/paid',
        },
      ],
      importantLinks: [
        {
          text: 'グリーンノート公式ウェブサイト',
          href: 'https://www.i-gnote.com',
        },
      ],
    }),
  }
</script>
